import { PULSE_VIEW_ID, trackPulseView } from './pulseViewIds';

/** Fires at most once per try2 item customization session (first modifier modal only). */
let customizationModalTracked = false;

export function resetTry2CustomizationModalTracking(): void {
  customizationModalTracked = false;
}

export function trackTry2CustomizationModalOnce(pagePath?: string): void {
  if (customizationModalTracked) return;
  customizationModalTracked = true;
  trackPulseView(PULSE_VIEW_ID.CUSTOMIZATION_MODAL, {
    page_path: pagePath ?? window.location.pathname,
  });
}
